
import Vue from 'vue'
import ExpectedTransformer from '@/transformers/workPlan/expected'

export default (payload) => {
	const transformed = ExpectedTransformer.send(payload)
	let url = 'workplan/expected/'

	return Vue.$http.post(url, transformed)
		.then(response => {
			const data = ExpectedTransformer.fetchCollection(response.data)
			return data
		})
}


// WEBPACK FOOTER //
// ./src/services/workPlan/sendExpected.js